module.exports = __webpack_public_path__ + "static/media/inspection-dvir.15eb9904.svg";